import React, { FocusEvent } from "react"
import { ReactComponent as AddToSearchIcon } from "../../../img/icons/add_to_search.svg"
import Icon from "@material-ui/core/Icon"

//Events
export type btnEvent = React.MouseEvent<HTMLButtonElement>
export type btnBlurEvent = FocusEvent<HTMLButtonElement>

export enum SVGIcon {
  AddToSearch = "add_to_search"
}

export interface ButtonProps {
  onClick: (event: btnEvent) => void
  className?: string
  idName?: string
  disabled?: boolean
  onBlur?: (event: btnBlurEvent) => void
  type?: "submit" | "reset" | "button"
  variant?: "primary" | "secondary"
  title?: string
  icon?: string | SVGIcon
  doubleIconName?: string
  autoFocus?: boolean
  panelBtn?: boolean
  dataField?: string
  tabIndex?: number
}

const Button: React.FunctionComponent<ButtonProps> = ({
  onClick,
  onBlur,
  children,
  variant,
  disabled,
  title,
  type,
  icon,
  className,
  idName,
  dataField,
  tabIndex,
  panelBtn: isPanelBtn
}) => {
  const btnIcon = !children ? " ocs-btn-only-icon" : ""
  const btnVariant = variant ? "ocs-btn-" + variant : ""
  const panelBtn = isPanelBtn ? "ocs-btn-panel" : ""

  const iconElement = icon ? (
    icon === SVGIcon.AddToSearch ? (
      <AddToSearchIcon className="ocs-md-btn-icon ocs-svg-btn-icon" />
    ) : (
      <Icon className="ocs-md-btn-icon">{icon}</Icon>
    )
  ) : null

  return (
    <button
      id={idName}
      className={`ocs-btn ${btnIcon} ${btnVariant} ${panelBtn} ${
        className ? className : ""
      }`}
      onClick={onClick}
      disabled={disabled}
      title={title}
      type={type}
      onBlur={onBlur}
      data-id={dataField}
      tabIndex={tabIndex}
    >
      {iconElement}
      {children && (
        <span className={!icon ? "ocs-btn-no-icon" : ""}>{children}</span>
      )}
    </button>
  )
}

export default Button
